import React, { Component } from 'react';
import AuthInput from '../../components/UI/AuthInput/AuthInput';
import Button from '../../components/UI/Button/Button';
import LazyHero from 'react-lazy-hero';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { Route, Redirect } from 'react-router-dom';
import './Auth.scss';

class Auth extends Component {
  state = {
    controls: {
      email: {
        elementType: 'input',
        elementConfig: {
          type: 'email',
          placeholder: 'Mail Address'
        },
        value: '',
        validation: {
          required: true,
          isEmail: true
        },
        valid: false,
        touched: false
      },
      password: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password'
        },
        value: '',
        validation: {
          required: true,
          minLength: 6
        },
        valid: false,
        touched: false
      }
    },
    isSignUp: true
  };

  checkValidity(value, rules) {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      isValid = value.trim() !== '' && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
      const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      isValid = pattern.test(value) && isValid;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  }

  inputChangedHandler = (evt, ctlName) => {
    const updatedControls = {
      ...this.state.controls,
      [ctlName]: {
        ...this.state.controls[ctlName],
        value: evt.target.value,
        valid: this.checkValidity(
          evt.target.value,
          this.state.controls[ctlName].validation
        ),
        touched: true
      }
    };
    this.setState({ controls: updatedControls });
  };

  onGuest = () => {
    const setup = {
      ...this.state.controls,
      email: {
        ...this.state.controls.email,
        value: 'test@test.com'
      },
      password: {
        ...this.state.controls.password,
        value: '123123'
      }
    };
    this.setState({ controls: setup });
  };

  submitHandler = evt => {
    evt.preventDefault();
    const {
      isSignUp,
      controls: { email, password }
    } = this.state;
    this.props.onUserAuthentication(email.value, password.value, isSignUp);
  };

  switchAuthModeHandler = () => {
    this.setState(prevState => {
      return { isSignUp: !prevState.isSignUp };
    });
  };

  render() {
    const { controls, isSignUp } = this.state;
    const { loading, error, userName, isAuthenticated } = this.props;

    const formElementsArray = Object.keys(controls).map(el => {
      return {
        id: el,
        config: controls[el]
      };
    });

    const form = formElementsArray.map(formElement => {
      return (
        <AuthInput
          key={formElement.id}
          elementType={formElement.config.elementType}
          elementConfig={formElement.config.elementConfig}
          value={formElement.config.value}
          invalid={!formElement.config.valid}
          shouldValidate={formElement.config.validation}
          touched={formElement.config.touched}
          changed={evt => this.inputChangedHandler(evt, formElement.id)}
        />
      );
    });

    let errorMessage;
    if (error) {
      errorMessage = <p style={{ color: 'white' }}>{error}</p>;
    }

    return (
      <>
        {
          <Route
            exact
            path="/login"
            render={() =>
              isAuthenticated ? <Redirect to={`/user/${userName}`} /> : null
            }
          />
        }
        <LazyHero
          className="auth"
          imageSrc={
            'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80'
          }
          minHeight="100vh"
          color="#141E30"
          opacity={0.5}
          isCentered={true}
          parallaxOffset={100}>
          <>
            <Button
              buttonType="auth-container-form__btn guest"
              clicked={this.onGuest}>
              Browse as guest
            </Button>
            {/* <div className="guest">
              <h2 className="guest-title"> Sign up as guest User:</h2>
              <p className="guest-login">Login: test@test.com</p>
              <p className="guest-password">Password: 123123</p>
            </div> */}
            <div
              className={`auth-container ${
                loading ? 'auth-container-fadein' : ''
              }`}>
              {errorMessage}
              <form
                className="auth-container-form"
                onSubmit={this.submitHandler}>
                {form}
                <Button buttonType="auth-container-form__btn" type={'submit'}>
                  Submit
                </Button>
              </form>
              <Button
                buttonType="auth-container-form__btn"
                clicked={this.switchAuthModeHandler}>
                Switch to {isSignUp ? 'Sign In' : 'Sign Up'}
              </Button>
            </div>
          </>
        </LazyHero>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.authReducer.loading,
  userName: state.authReducer.userName,
  error: state.authReducer.error,
  isAuthenticated: state.authReducer.token !== null
});

const mapDispatchToProps = dispatch => ({
  onUserAuthentication: (email, password, isSignup) =>
    dispatch(actions.userAuthentication(email, password, isSignup))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth);
